<div
  class="attendance-status-indicator"
  [ngClass]="attendanceStatusColorMap[attendanceUser?.status]"
>
  <!--  Button when clicked will trigger the mat menu used for updating the status-->
  <!--  Button is disabled if the attendance is for the canceled event -->
  <button
    mat-button
    class="status-btn-container"
    [matMenuTriggerFor]="mode === AttendanceStatusMode.EDITABLE && statusMenu"
    [appTooltip]="statusButtonTooltip"
    [appTooltipPlacement]="'top-center'"
    [appTooltipDisabled]="!statusButtonTooltipText"
    [disableRipple]="shouldDisableButton"
    [class.disabled]="shouldDisableButton"
    (click)="handleStatusPillClick()"
  >
    <app-pencil-spinner
      [diameter]="18"
      [strokeWidth]="2"
      *ngIf="isUpdating$ | async; else statusButtonContent"
    >
    </app-pencil-spinner>
    <ng-template #statusButtonContent>
      <!-- Show notes icon if notes exist -->
      <app-pencil-icon
        *ngIf="attendanceUser.notes && mode !== AttendanceStatusMode.READ_ONLY"
        class="edit-note-icon"
        name="edit_note"
        type="svg-icon"
      ></app-pencil-icon>
      <span class="attendance-status-text">
        {{ attendanceUser?.status | translate }}
      </span>
      <!--    expand icon will be displayed only if the event isn't the canceled event -->
      <app-pencil-icon
        *ngIf="mode === AttendanceStatusMode.EDITABLE"
        name="expand_more"
        type="material-icon"
      >
      </app-pencil-icon>
    </ng-template>
  </button>
  <!--  mat menu will be used for displaying attendance status-->
  <mat-menu #statusMenu="matMenu" class="attendance-status-menu" xPosition="before">
    <ng-container *ngFor="let updateStatus of attendanceStatuses; trackBy: trackByStatusCode">
      <button
        mat-menu-item
        class="menu-button"
        (click)="onStatusSelect(updateStatus.statusCode)"
        [class.active]="
          attendanceUser?.status?.toLowerCase() === updateStatus.statusCode.toLowerCase()
        "
      >
        <span>{{ updateStatus.displayName }} </span>
        <app-pencil-icon
          *ngIf="attendanceUser?.status?.toLowerCase() === updateStatus.statusCode.toLowerCase()"
          name="check"
          type="material-icon"
        >
        </app-pencil-icon>
      </button>
    </ng-container>

    <app-pncl-menu-divider></app-pncl-menu-divider>
    <!--    Notes Button that will trigger the dialog -->
    <button mat-menu-item class="menu-button" (click)="showNotesDialog()">
      <span
        >{{ attendanceUser?.notes ? ('Edit note' | translate) : ('Add note' | translate) }}
      </span>
    </button>
  </mat-menu>
</div>

<!-- Tooltip will be used when the current status is canceled or to see the view note tooltip  -->
<ng-template #statusButtonTooltip>
  <app-tooltip
    arrow="bottom"
    [text]="statusButtonTooltipText"
    [style.width.px]="200"
    [createNewLine]="true"
    [tipStyle]="{ left: '50%' }"
  >
  </app-tooltip>
</ng-template>
